import { useQuery } from '@tanstack/react-query'

import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { QueryKey } from '../../domain/dtos/query-keys'
import { GetMovementsByInvoiceId } from '../../usecases/get-movements-by-invoice-id'

export const useGetMovementsByInvoiceId = (invoiceId: string | undefined) => {
  const container = useContainer()
  return useQuery(
    [QueryKey.getMovementsByInvoiceId],
    () => new GetMovementsByInvoiceId(container.get(HttpClient)).execute({ invoiceId: invoiceId ?? '' }),
    {
      enabled: !!invoiceId,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retry: 3,
    },
  )
}
